import useRefillAreaName from "../../hooks/useRefillAreaName";
import { FixaListViewItem } from "../../../shared/wrappers/FixaListView/FixaListViewItem";
import { RefillArea } from "../../types/departments";

interface RefillAreaListItemProps {
  refillArea: RefillArea;
  key: string;
  onClick: () => void;
  searchQuery: string;
}

export const RefillAreaListItem = ({
  refillArea,
  key,
  onClick,
  searchQuery,
}: RefillAreaListItemProps) => {
  const title = useRefillAreaName(refillArea.area);

  const normalizedTitle = title.replace(/\s+/g, "").toLowerCase();
  const normalizedQuery = searchQuery.replace(/\s+/g, "").toLowerCase();

  if (
    normalizedQuery.length > 1 &&
    !normalizedTitle.includes(normalizedQuery)
  ) {
    return null;
  }

  return (
    <FixaListViewItem
      key={key}
      id={refillArea.area}
      data-testid={`refill-area-${refillArea.area}`}
      inset
      emphasised
      title={title}
      controlIcon="chevronRight"
      control="navigational"
      onClick={onClick}
    />
  );
};
